import { render } from "./ReleaseNoteModal.vue?vue&type=template&id=43adabce&scoped=true"
import script from "./ReleaseNoteModal.vue?vue&type=script&lang=js"
export * from "./ReleaseNoteModal.vue?vue&type=script&lang=js"

import "./ReleaseNoteModal.vue?vue&type=style&index=0&id=43adabce&scoped=true&lang=css"
import "./ReleaseNoteModal.vue?vue&type=style&index=1&id=43adabce&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.18_vue@3.5.18_webpack@5.101.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43adabce"]])

export default __exports__